import React from 'react';
import PropTypes from 'prop-types';

import LocalOffer from '@material-ui/icons/LocalOffer';
import MoneyOff from '@material-ui/icons/MoneyOff';
import Payment from '@material-ui/icons/Payment';
import DateRange from '@material-ui/icons/DateRange';

import { propTypes as i18nPropTypes } from '../../../../../hocs/intlEquipped';
import { paymentPropType, productPropType } from '../../../../../types/subscription';

import SubscriptionPaymentDetail from '../../SubscriptionPaymentDetail';
import { formatDiscount, formatRecurringBilling, getPriceAndDateByConditions } from '../helpers';

import DetailInlineSection from '../DetailInlineSection';

const DefaultDetailsContent = ({ product, payment, theme, i18n }) => {
    const { formatMessage } = i18n;
    const { price, date } = getPriceAndDateByConditions({ product, payment, i18n });

    const recurringBilling = formatRecurringBilling({ product, payment, i18n });
    const discount = formatDiscount({ payment, i18n });

    return (
        <>
            { recurringBilling && (
                <DetailInlineSection
                    detail={ recurringBilling }
                    icon={{ component: <LocalOffer className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.priceSection') }
                    theme={ theme }
                />
            ) }
            { discount && (
                <DetailInlineSection
                    detail={ discount }
                    icon={{ component: <MoneyOff className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.discountSection') }
                    theme={ theme }
                />
            ) }
            { price && (
                <DetailInlineSection
                    detail={ price }
                    detailClass={ theme.priceDetail }
                    icon={{ component: <Payment className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.toPaySection') }
                    theme={ theme }
                />
            ) }
            { date && (
                <DetailInlineSection
                    detail={ date }
                    icon={{ component: <DateRange className={ theme.detailIcon } /> }}
                    title={ formatMessage('subscription.nextPaymentSection') }
                    theme={ theme }
                />
            ) }
            { payment.type && (
                <SubscriptionPaymentDetail
                    payment={ payment }
                    theme={ theme }
                    formatMessage={ formatMessage }
                />
            ) }
        </>
    );
};

DefaultDetailsContent.propTypes = {
    product: productPropType.isRequired,
    payment: paymentPropType.isRequired,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default DefaultDetailsContent;
